module.exports = __webpack_public_path__ + "static/media/cargando_passcoopeuch_exito.52c51a7f.svg";